import { Component, ViewChild } from '@angular/core';
import { Content } from 'ionic-angular';
import { IonicPage, NavController } from 'ionic-angular';

import { LoadingController, Loading } from 'ionic-angular';

// @reference https://github.com/ackerapple/ack-angular-webcam
// Imported here just for type checking. Optional.
import { WebCamComponent } from 'ack-angular-webcam';

import { MainPage } from '../main/main';

import { AlertProvider } from '../../providers/alert/alert';
import { MediaProvider } from '../../providers/media/media';
import { DateTimeProvider } from '../../providers/datetime/datetime';
import { QuizzServerProvider } from '../../providers/quizz-server/quizz-server';
import { ProofServerProvider } from '../../providers/proof-server/proof-server';

import { MediaItem } from '../../models/mediaitem';

/**
 * Generated class for the IdentificationCheckOnAppPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-quizz-question-selfie-on-web',
  templateUrl: 'quizz-question-selfie-on-web.html',
})
export class QuizzQuestionSelfieOnWebPage {

  @ViewChild(Content) content: Content;
  @ViewChild('photoWebcam') photoWebcam: WebCamComponent;

  loader: Loading;
  detectingWebcam: boolean = true;
  hasWebcam: boolean = true;
  isWebcamRequired: boolean = false;

  // Will be populated by <ack-webcam [(ref)]="webcam">
  selfieColor: string = 'danger';
  // selfieWebcam: WebCamComponent;
  selfieBase64: string;

  quizzId: number = null;
  questionId: number = null;

  constructor(
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private alertProvider: AlertProvider,
    private mediaProvider: MediaProvider,
    private dateTimeProvider: DateTimeProvider,
    private quizzServerProvider: QuizzServerProvider,
    private proofServerProvider: ProofServerProvider,
  ) {
    this.isWebcamRequired = true;
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad QuizzQuestionSelfieOnWebPage');
    const that = this;

    this.quizzId = this.quizzServerProvider.getQuizzId();
    this.questionId = this.quizzServerProvider.getQuestionId();

    // console.log(this.quizzId, this.questionId);

    this.loader = this.loadingCtrl.create({
      content: 'Verificando se existe webcam e sua permissão de acesso...'
    });
    this.loader.present();

    this.mediaProvider.detectWebcam((hasWebcam: boolean) => {
      // console.log('Webcam: ' + ((hasWebcam) ? 'yes' : 'no'));
      that.hasWebcam = hasWebcam;
      that.detectingWebcam = false;
      that.loader.dismiss();
    });
  }

  onCamError(err: any) {
    console.log(err);

    if (this.hasWebcam) {
      this.hasWebcam = false;
    }

    this.content.scrollToTop();
  }

  onCamSuccess() {
    this.loader.dismiss();
  }

  takeSelfie() {
    if ((this.hasWebcam) && (this.selfieColor === 'danger')) {
      let that = this;

      this.mediaProvider.takeWebcamPicture(this.photoWebcam, (data: string) => {
        that.selfieColor = 'primary';
        that.selfieBase64 = data;

        let item = new MediaItem();
        item.id = that.dateTimeProvider.getISOString();
        item.kind = 'QT';
        item.questionId = that.questionId;
        item.contentOrPath = data;
        item.captured = item.id;
        // console.log(item);

        that.proofServerProvider.setMedias([item]);
        //that.proofServerProvider.sendMediaItem(that.quizzId);
      });
    }
  }

  takeSelfieAgain() {
    if (this.selfieColor === 'primary') {
      this.selfieColor = 'danger';
    }
  }

  doContinue() {
    if ((this.hasWebcam) && (this.selfieColor !== 'danger')) {
      this.navCtrl.setRoot(MainPage);
      this.navCtrl.popToRoot({
        animation: 'ios-transition'
      }, () => {
        // Do nothing.
      });
    } else {
      this.alertProvider.doAlert('Existem informações a serem fornecidas.');
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/quizz-question-selfie-on-web/quizz-question-selfie-on-web.ts